// eslint-disable-next-line no-undef
const RAW_API = process.env.REACT_APP_API_URL || '';

/** Base já inclui /api/hicell quando definido assim no .env */
export const API_BASE = RAW_API.replace(/\/+$/, '');

/** Monta URL de API a partir da base já com /api/hicell */
export const buildApiUrl = (path = '') => {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${p}`;
};

/** Trata corretamente URLs absolutas e esquemas especiais */
const isAbsoluteOrSpecial = (u) => /^(https?:|blob:|data:|\/\/)/i.test(u);

/** Resolve URL de imagem para exibição no front */
export const resolveImageUrl = (imageLink) => {
  if (!imageLink) return null;

  // Se for http(s), blob:, data: ou protocol-relative (//), retorna como veio
  if (isAbsoluteOrSpecial(imageLink)) return imageLink;

  // Caso comum: link relativo que começa com /static
  const link = imageLink.startsWith('/') ? imageLink : `/${imageLink}`;
  return `${API_BASE}${link}`;
};
